<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> RSS-Feed anlegen </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addForm">
                    <div class="row" *ngIf="uploadImage">
                        <div class="col-sm-12">
                            <div ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png'" (change)="onSelect($event)">
                                <ngx-dropzone-label>
                                    <div>
                                        <h3>Bild hierher ziehen</h3>
                                        <h5>ODER</h5>
                                        <button mat-raised-button color="accent">Durchsuchen</button>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                </ngx-dropzone-image-preview>
                            </div>
                            <mat-error *ngIf="addForm.get('image').hasError('required')">
                                Bild <strong>muss</strong> angegeben werden
                            </mat-error>
                        </div>
                    </div>
                    <div class="row imageContainer" *ngIf="this.addForm.value?.image?.url">
                        <img src="{{this.addForm.value?.image.url}}" alt="">
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div *ngFor="let p of imageProperties" class="centerVerticalAndHoritontal marginTop2Rem">
                                <button mat-raised-button color="primary" (click)="openImageGallery(p)">Bild
                                    auswählen</button>
                            </div>
                        </div>

                        <div class="col-sm-6" *ngIf="!uploadImage">
                            <div *ngFor="let p of imageProperties" class="centerVerticalAndHoritontal marginTop2Rem">
                                <button mat-raised-button color="accent" (click)="resetImage()">Bild
                                    hochladen</button>
                            </div>
                        </div>
                    </div>
                    <div class="row marginTop2Rem">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Typ:</mat-label>
                                <mat-select formControlName="type">
                                    <mat-option *ngFor="let sortOption of stateOptions" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addForm.get('type').hasError('required')">
                                    Typ <strong>muss</strong> angegeben werden
                                </mat-error>                            
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Quelle (Url):</mat-label>
                                <input matInput type="url" formControlName="feedUri">
                                <mat-error *ngIf="addForm.get('feedUri').hasError('required')">
                                    Quelle (Url) <strong>muss</strong> angegeben werden
                                </mat-error>
                                <mat-error *ngIf="addForm.get('feedUri').hasError('pattern')">
                                    Quelle (Url) <strong>muss</strong> gültiges Format haben (https://....))
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row marginTop2Rem">
                        <div class="col-sm-12">
                            <mat-checkbox formControlName="autoFetch">
                            <span>Stündlich automatisch aktualisieren: </span>
                          </mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-checkbox formControlName="hasUsername">
                            <span>RSS-Feed nutzt Authentifikation: </span>
                          </mat-checkbox>
                        </div>
                    </div>
                    <div class="row" *ngIf="this.addForm.value.hasUsername">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Benutzername:</mat-label>
                                <input matInput type="text" formControlName="username">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Passwort:</mat-label>
                                <input matInput type="text" formControlName="password">
                            </mat-form-field>
                        </div>                        
                    </div>                
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" [routerLink]="['/caseworker/rssFeed']">Abbrechen</button>
                    <button mat-button color="primary" (click)="createRSSFeed()">RSS-Feed Hinzufügen</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>